import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleNavItem,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { provideLocalhostPermissions } from '@softline/auth';
import { default as de } from '../i18n/de.json';
import { designSystemRoutes } from './design-system.routes';

const DESIGN_SYSTEM_CATALOG_PERMISSION = 'SOFTAPPS.DESIGN_SYSTEM_CATALOG';

export const provideDesignSystemCatalogModule = () => [
  provideSoftAppsModule(
    {
      name: 'DesignSystemCatalog',
      title: '#DESIGN_SYSTEM_CATALOG.TITLE',
      icon: 'fa-regular fa-swatchbook',
      route: '/design-system',
      group: getModuleGroupByName('Technik'),
      permission: DESIGN_SYSTEM_CATALOG_PERMISSION,
      badge: 'docs',
    },
    withSoftAppsModuleRoutes({ app: designSystemRoutes }),
    withSoftAppsModuleTranslation({ de }),
    withSoftAppsModuleNavItem([
      {
        name: 'design-system-overview',
        title: '#DESIGN_SYSTEM_CATALOG.TITLE',
        icon: 'fa-regular fa-swatchbook',
        routerLink: ['/design-system/overview'],
        entry: true,
      },
    ]),
    withSoftAppsModuleInfo({
      library: '@softapps/design-system-catalog',
      description: 'Katalog der Design-System-Komponenten und Tokens.',
    })
  ),
  ...provideLocalhostPermissions(DESIGN_SYSTEM_CATALOG_PERMISSION),
];
